import { makeFupIcon } from './FupIconFactory';
export default makeFupIcon('MUX4');
